import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=8a8be620&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=8a8be620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8be620",
  null
  
)

export default component.exports